import {
  CheckEmptyTextField,
  CheckIsEmail,
  CheckOnlyDigit,
  CheckLengthEqual,
} from "components/ValidationHelper";
import store from "./store";

export const validate = (event: { target: { name: string; value: any } }) => {
  let organization_code = "";
  if (event.target.name === "organization_code") {
    let organization_codeErrors = [];
    CheckEmptyTextField(event.target.value, organization_codeErrors);
    organization_code = organization_codeErrors.join(", ");
    store.errororganization_code = organization_code;
  }

  let name = "";
  if (event.target.name === "name") {
    let nameErrors = [];
    CheckEmptyTextField(event.target.value, nameErrors);
    name = nameErrors.join(", ");
    store.errorname = name;
  }

  let organization_type = "";
  if (event.target.name === "organization_type") {
    let organization_typeErrors = [];
    CheckEmptyTextField(event.target.value, organization_typeErrors);
    organization_type = organization_typeErrors.join(", ");
    store.errororganization_type = organization_type;
  }

  let inn = "";
  if (event.target.name === "inn") {
    let innErrors = [];
    CheckEmptyTextField(event.target.value, innErrors);
    CheckOnlyDigit(event.target.value, innErrors);
    CheckLengthEqual(event.target.value, 14, innErrors);
    inn = innErrors.join(", ");
    store.errorinn = inn;
  }

  let email = "";
  if (event.target.name === "email") {
    let emailErrors = [];
    CheckIsEmail(event.target.value, emailErrors);
    email = emailErrors.join(", ");
    store.erroremail = email;
  }

  const canSave = 
    organization_code === "" && 
    name === "" && 
    organization_type === "" && 
    inn === "" && 
    email === "";

  return canSave;
};